module.exports = __webpack_public_path__ + "static/media/akp.d0232993.png";